import TopBarProgress from 'react-topbar-progress-indicator';

/**
 * Configure and Initialize the TopBarProgress component
 *
 * Author: Muhammad Rooman
 * Date: 15 Sep, 2024
 */

TopBarProgress.config({
    barColors: {
        1: '#34A595',
        '1.0': '#34A595',
    },
    shadowBlur: 5,
});

export default TopBarProgress;
